var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCheckCircleFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "xos72b6ica"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#xos72b6ica)",
    transform: "translate(-54 -1008) translate(24 984)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#118647"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.333.832c6.904 0 12.5 5.597 12.5 12.5 0 6.904-5.596 12.5-12.5 12.5-6.903 0-12.5-5.596-12.5-12.5 0-6.903 5.597-12.5 12.5-12.5zm7.287 5.97c-.433-.342-1.062-.269-1.405.165l-8.714 11.025-.046.047c-.032.024-.067.035-.103.034-.053-.002-.102-.03-.132-.074l-2.736-3.883-.094-.114c-.336-.353-.889-.416-1.3-.127-.45.318-.559.942-.24 1.393l2.721 3.864.121.162c.385.467.971.759 1.6.778.7.02 1.367-.298 1.79-.855l8.703-11.01.083-.123c.243-.423.146-.97-.248-1.282z",
    transform: "translate(30 24) translate(2.667 2.667)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFilled);
export default __webpack_public_path__ + "static/media/check-circle-filled.aaf9ddc9e105ab6e43346231b9969d3c.svg";
export { ForwardRef as ReactComponent };